<template lang="pug">
div.padding
    div.row
        div.col-md-12
            span._300.block.text-md.m-b-md Tags

        div.col-md-12
            div.box
                v-server-table(
                    :url="api",
                    :name="tableName",
                    ref="datatable",
                    :columns="columns",
                    :options="options"
                )
                    template(slot="parent", slot-scope="props")
                        span(v-if="props.row.parent !== null") {{ props.row.parent.name }}

                    template(slot="product", slot-scope="props")
                        span
                            i {{ props.row.products_count }} assigned product{{ props.row.products_count > 1 ? 's' : '' }}
</template>

<script>
import { Event } from '@js/event-bus';

export default {
    data() {
        var vm = this;
        return {
            tableName: 'VUETABLE_TAG',
            columns: ['name', 'parent', 'description', 'product'],
            options: {
                permission: {
                    create: () => this.permission.SAVE_TAG,
                    delete: () => this.permission.DELETE_TAG,
                },
                sortable: ['name', 'parent', 'description'],
                checkbox: {
                    api_delete: Laroute.route('settings.tags.delete'),
                    delete_title: 'Delete Tag',
                },
                orderBy: { column: 'name', ascending: 1 },
                create_btn: {
                    title: 'New Tag',
                    action: () => {
                        this.$router.push('/create');
                    },
                },
                rowClassCallback: row => (this.canUpdate ? 'pointer' : ''),
                rowClickCallback: row => {
                    if (this.canUpdate) this.$router.push(`/${row.id}`);
                },
            },
        };
    },
    computed: {
        api() {
            return Laroute.route('settings.tags.index');
        },

        canUpdate() {
            return this.can(this.permission.SAVE_TAG);
        },
    },
    created() {
        Event.$on('tag-updated', () => {
            this.$refs.datatable.getData();
        });
    },
    methods: {},
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/settings/tag/tag-list.vue